
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3034',
  depVersions: {
  "customer-portal-app": "static-1.3034",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.493",
  "data-fetching-client": "static-1.9917",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26101",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5854",
  "hs-test-utils": "static-1.8288",
  "hub-http": "static-1.6472",
  "hub-http-shared-msw-handlers": "static-1.10548",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18895",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11743",
  "I18n": "static-7.1665",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6710",
  "payment-link-components": "static-1.24097",
  "portals-platform-bend-plugin": "static-1.19",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7393",
  "quartz-core": "static-1.6612",
  "quartz-i18n": "static-1.1068",
  "react": "static-7.191",
  "react-colorpicker": "static-2.10467",
  "react-dlb": "static-1.86",
  "react-utils": "static-2.5527",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20251",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18332",
  "ui-components-test-utils": "static-1.5880",
  "UIComponents": "static-3.8689",
  "foundations-assets": "static-1.5143",
  "foundations-components": "static-1.8416",
  "foundations-theming": "static-1.4726",
  "foundations-theming-specialty": "static-1.2442",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1368",
  "quartz-config": "static-1.1171",
  "quartz-routing": "static-1.823",
  "quick-fetch": "static-1.4103",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16971",
  "rpc-client-utils": "static-1.4922",
  "sanitize-text": "static-1.8410",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5015",
  "ui-addon-react-router-dom": "static-1.9796",
  "usage-tracker": "static-1.7616",
  "usage-tracker-anonymous": "static-1.6033",
  "usage-tracker-core": "static-1.7466",
  "video-components-external": "static-1.12085",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3590",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3670",
  "quartz-webpack": "static-1.3617",
  "bend-plugin-quartz-routing": "static-1.471",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7947",
  "frontend-preferences-client": "static-1.8186",
  "laboratory-lib": "static-3.7411",
  "onboarding-scopes": "static-1.6713",
  "seat-types-lib": "static-1.653",
  "ui-addon-opt": "static-4.8625",
  "HeadJS": "static-2.790",
  "hs-test-utils-bend-plugin": "static-1.3399",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.264",
  "ts-schema": "static-1.4265",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8147",
  "content-media-capture": "static-1.5342",
  "cssUtils": "static-1.876",
  "customer-data-ui-utilities": "static-1.10087",
  "file-manager-components": "static-1.24394",
  "HubStyle": "static-2.12050",
  "knowledge-content-types": "static-1.8627",
  "PatternValidationJS": "static-1.3157",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.496",
  "ui-addon-emoji-picker": "static-1.10145",
  "ui-addon-i18n": "static-1.11403",
  "ui-business-units-lib": "static-1.9343",
  "ui-shepherd-react": "static-3.10524",
  "video-data-lib": "static-1.35743",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4576",
  "commerce-tours-lib": "static-1.6553",
  "customer-data-properties": "static-1.52469",
  "getting-started-shared-tasks": "static-1.19144",
  "growth-onboarding-reliability": "static-1.5340",
  "onboarding-tours": "static-1.17060",
  "reference-resolvers-lite": "static-1.8360",
  "sales-checkout-service-client": "static-1.3788",
  "ui-addon-iframeable": "static-1.9334",
  "user-context": "static-1.5376",
  "bender-build-tools": "static-1.3392",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4835",
  "icons": "static-2.675",
  "mobile-manifest-mixins": "static-1.569",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.404",
  "quartz-auth": "static-1.1068",
  "quartz-head": "static-1.1058",
  "quartz-test": "static-1.1068",
  "quartz-tracking": "static-1.772",
  "trellis-components": "static-1.2534",
  "ui-fonts": "static-1.1005",
  "usage-tracker-container": "static-1.7606",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9686",
  "data-token-picker": "static-1.16833",
  "FileManagerLib": "static-1.40034",
  "property-translator": "static-1.5656",
  "atom": "static-1.5345",
  "merchandise-lib": "static-1.274",
  "purchase-motions-components": "static-1.6298",
  "salesImages": "static-1.531",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5899",
  "react-create-root-preference": "static-1.64",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1233",
  "bend-plugin-foundations-components": "static-1.4685",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2515",
  "bend-plugin-foundations-theming": "static-1.3209",
  "foundations-theming-base": "static-1.3711",
  "stylex": "static-1.38",
  "interframe": "static-3.5015",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6030",
  "opentelemetry-fe-types": "static-1.29",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.332",
  "chirp-fetch": "static-1.2153",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4735",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4915",
  "content-media-composition-data-lib": "static-1.13146",
  "content-media-compositions": "static-2.17153",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4410",
  "magpie-lib": "static-1.5727",
  "magpie-types": "static-1.5187",
  "media-bridge-lib": "static-1.19351",
  "inbound-db-properties-service-client": "static-1.4029",
  "superstore": "static-1.5015",
  "feedback-loader": "static-1.29752",
  "ai-components-ui-library": "static-1.9626",
  "ui-addon-video-player": "static-1.8963",
  "ui-coaching-tips": "static-1.29239",
  "ContentUtils": "static-1.69063",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4685",
  "sassPrefix": "static-1.163",
  "react-dnd-compat": "static-1.4875",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1604",
  "copilot-toolkit": "static-1.11772",
  "avatar-components": "static-1.2754",
  "navigation-messaging": "static-1.8063",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8439",
  "commerce-products-lib": "static-1.10441",
  "crm-message-bus": "static-1.43669",
  "growth-data-modal": "static-1.5836",
  "hubspot-apollo-client": "static-1.5138",
  "onboarding-tours-client": "static-1.5274",
  "batch-promise": "static-1.1800",
  "calling-global-api": "static-1.65427",
  "calling-internal-common": "static-1.31578",
  "calling-lifecycle-internal": "static-1.66809",
  "calling-lifecycle-messages": "static-1.59103",
  "conditional-properties-service-client": "static-1.3985",
  "crm-index-visualization-core": "static-1.4489",
  "crm-links": "static-1.6585",
  "crm-pipelines-api-client-types": "static-1.4319",
  "customer-data-objects-ui-components": "static-1.13289",
  "customer-data-properties-shared-msw-handlers": "static-1.9875",
  "customer-data-property-utils": "static-1.8357",
  "external-options-client-types": "static-1.4312",
  "formula-editor": "static-1.14692",
  "framework-data-schema-resolvers": "static-1.7152",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.450",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4396",
  "meetings-icalendar-utils-lib": "static-1.894",
  "multi-currency-client-types": "static-1.3880",
  "object-builder-ui-client": "static-1.49575",
  "pipeline-validation-client-types": "static-1.4154",
  "property-value-citations": "static-1.3083",
  "pulse": "static-1.884",
  "smart-data-capture-core": "static-1.54",
  "smart-property-lib": "static-1.8201",
  "tiered-pricing": "static-1.1892",
  "trial-components-library": "static-1.14043",
  "topics-actions-lib": "static-1.424",
  "ui-addon-form-validation": "static-1.11245",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3322",
  "growth-onboarding-next-action-utils": "static-1.2620",
  "navigation-components": "static-1.18736",
  "onboarding-tours-utils": "static-1.1126",
  "ui-shepherd-tracker": "static-1.7905",
  "ui-universal-auth": "static-1.9319",
  "getting-started-shared-tasks-store": "static-1.18262",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10546",
  "usage-tracker-session-replay": "static-1.5302",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1226",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6287",
  "FileManagerCore": "static-1.39893",
  "FileManagerImages": "static-1.37545",
  "video-components": "static-1.14087",
  "foundations-components-legacy": "static-1.1441",
  "purchase-motions-api": "static-1.6301",
  "signup-constants": "static-1.19537",
  "signup-ui-url-generator": "static-2.8319",
  "usage-tracker-public": "static-1.7427",
  "reactive-lib": "static-1.981",
  "simple-logging-lib": "static-1.3310",
  "chatspot-core": "static-1.22712",
  "growth-onboarding-feedback-components": "static-1.6844",
  "cms-field-types": "static-1.5074",
  "content-icons-ui": "static-1.2323",
  "integrations-lib": "static-1.16954",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.582",
  "breeze-engine-core": "static-1.882",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1036",
  "customer-data-tracking": "static-1.7141",
  "products-iframe-lib": "static-1.8519",
  "products-ui-components-shared-msw-handlers": "static-1.10930",
  "restore-request-side-panel-lib": "static-1.1588",
  "onboarding-data-sync-lib": "static-1.2436",
  "hubspot-apollo-cache": "static-1.597",
  "calling-error-reporting": "static-1.31585",
  "shared-worker-versioning": "static-1.11299",
  "calling-usage-tracker": "static-1.6798",
  "voice-sms-access-library": "static-1.1937",
  "conversations-skeleton-state": "static-1.7508",
  "crm-index-associations-lib": "static-1.6701",
  "framework-data-schema-quick-fetch": "static-1.7057",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10631",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4516",
  "location-customization-utils-lib": "static-1.10017",
  "bark-lib": "static-1.16766",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6149",
  "react-codemirror": "static-1.10898",
  "fdsr-migration-layer": "static-1.271",
  "framework-builder-read-service-client": "static-1.4193",
  "persist-promise": "static-1.3957",
  "event-emitter": "static-1.1213",
  "bend-plugin-pulse": "static-1.387",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.590",
  "fsm": "static-1.4000",
  "policy-lib": "static-1.7055",
  "react-tinymce": "static-1.55902",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10694",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55028",
  "tinymce-plugins": "static-1.58142",
  "tinymce-themes": "static-1.56998",
  "embedded-academy-lib": "static-1.15404",
  "hubs-service-types": "static-1.1518",
  "growth-onboarding-next-action-components": "static-1.2648",
  "user-context-client": "static-1.4768",
  "nest": "static-1.495",
  "unified-auth-core-lib": "static-1.1115",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.224",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4792",
  "video-embed": "static-1.36577",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.362",
  "integrations-error-boundary-lib": "static-1.14369",
  "integrations-tracking-lib": "static-1.5867",
  "native-integrations-shared-strings": "static-1.8037",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10627",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.833",
  "InboxConnectUtils": "static-4.15482",
  "meetings-connect-utils-lib": "static-1.7869",
  "calling-orchestration-schema": "static-1.36714",
  "crm-record-cards-service-types": "static-1.3759",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16291",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4770",
  "storybook-react": "static-1.37",
  "hub-http-contrib": "static-1.3296",
  "tinymce-data": "static-1.41113",
  "ui-addon-sales-email": "static-1.5475",
  "layout-dnd-components": "static-1.12907",
  "layout-dnd-utils": "static-1.11882",
  "ui-brand-identity-lib": "static-1.16277",
  "NamespacedHubStyle": "static-2.9234",
  "academy-common-lib": "static-1.14864",
  "outpost": "static-1.4419",
  "universal-page-editor-lib": "static-1.3266",
  "adobe-sign-auth-lib": "static-1.379",
  "ads-unified-auth-lib": "static-1.1130",
  "google-sheets-integration-lib": "static-1.955",
  "microsoft-drive-auth-lib": "static-1.52",
  "surveymonkey-integration-lib": "static-1.399",
  "slack-ui-library": "static-1.10658",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10207",
  "academy-service-client": "static-1.3948",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4664",
  "trellis-ecosystem": "static-1.7578",
  "wootric-nps": "static-1.7171",
  "advanced-menus-core": "static-1.15523",
  "advanced-menus-lib": "static-1.12402",
  "ExportDialog": "static-6.10638",
  "ui-memberships-settings-lib": "static-1.34766",
  "marketplace-ui-apps-core": "static-1.19163",
  "marketplace-ui-common": "static-1.20631",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15522",
  "simple-menus-lib": "static-1.17039",
  "developer-experience-shared-components": "static-1.10763",
  "immutable-less": "static-1.4910",
  "marketplace-ui-client-types": "static-1.18038",
  "ui-addon-integrations-directory-panel": "static-2.8286",
  "ui-extensibility-client-types": "static-1.4180",
  "ai-settings-ui-library": "static-1.8271",
  "nav-meta": "static-1.30373",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.915",
  "apps-service-types": "static-1.4000",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3461"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3034",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.493",
  "data-fetching-client": "/data-fetching-client/static-1.9917",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26101",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5854",
  "hs-test-utils": "/hs-test-utils/static-1.8288",
  "hub-http": "/hub-http/static-1.6472",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10548",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18895",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11743",
  "I18n": "/I18n/static-7.1665",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6710",
  "payment-link-components": "/payment-link-components/static-1.24097",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.19",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7393",
  "quartz-core": "/quartz-core/static-1.6612",
  "quartz-i18n": "/quartz-i18n/static-1.1068",
  "react": "/react/static-7.191",
  "react-colorpicker": "/react-colorpicker/static-2.10467",
  "react-dlb": "/react-dlb/static-1.86",
  "react-utils": "/react-utils/static-2.5527",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20251",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18332",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5880",
  "UIComponents": "/UIComponents/static-3.8689",
  "foundations-assets": "/foundations-assets/static-1.5143",
  "foundations-components": "/foundations-components/static-1.8416",
  "foundations-theming": "/foundations-theming/static-1.4726",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2442",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1368",
  "quartz-config": "/quartz-config/static-1.1171",
  "quartz-routing": "/quartz-routing/static-1.823",
  "quick-fetch": "/quick-fetch/static-1.4103",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16971",
  "rpc-client-utils": "/rpc-client-utils/static-1.4922",
  "sanitize-text": "/sanitize-text/static-1.8410",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5015",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9796",
  "usage-tracker": "/usage-tracker/static-1.7616",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6033",
  "usage-tracker-core": "/usage-tracker-core/static-1.7466",
  "video-components-external": "/video-components-external/static-1.12085",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3590",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3670",
  "quartz-webpack": "/quartz-webpack/static-1.3617",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.471",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7947",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8186",
  "laboratory-lib": "/laboratory-lib/static-3.7411",
  "onboarding-scopes": "/onboarding-scopes/static-1.6713",
  "seat-types-lib": "/seat-types-lib/static-1.653",
  "ui-addon-opt": "/ui-addon-opt/static-4.8625",
  "HeadJS": "/HeadJS/static-2.790",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3399",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.264",
  "ts-schema": "/ts-schema/static-1.4265",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8147",
  "content-media-capture": "/content-media-capture/static-1.5342",
  "cssUtils": "/cssUtils/static-1.876",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10087",
  "file-manager-components": "/file-manager-components/static-1.24394",
  "HubStyle": "/HubStyle/static-2.12050",
  "knowledge-content-types": "/knowledge-content-types/static-1.8627",
  "PatternValidationJS": "/PatternValidationJS/static-1.3157",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10145",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11403",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9343",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10524",
  "video-data-lib": "/video-data-lib/static-1.35743",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4576",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6553",
  "customer-data-properties": "/customer-data-properties/static-1.52469",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19144",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5340",
  "onboarding-tours": "/onboarding-tours/static-1.17060",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8360",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3788",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9334",
  "user-context": "/user-context/static-1.5376",
  "bender-build-tools": "/bender-build-tools/static-1.3392",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4835",
  "icons": "/icons/static-2.675",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.569",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.404",
  "quartz-auth": "/quartz-auth/static-1.1068",
  "quartz-head": "/quartz-head/static-1.1058",
  "quartz-test": "/quartz-test/static-1.1068",
  "quartz-tracking": "/quartz-tracking/static-1.772",
  "trellis-components": "/trellis-components/static-1.2534",
  "ui-fonts": "/ui-fonts/static-1.1005",
  "usage-tracker-container": "/usage-tracker-container/static-1.7606",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9686",
  "data-token-picker": "/data-token-picker/static-1.16833",
  "FileManagerLib": "/FileManagerLib/static-1.40034",
  "property-translator": "/property-translator/static-1.5656",
  "atom": "/atom/static-1.5345",
  "merchandise-lib": "/merchandise-lib/static-1.274",
  "purchase-motions-components": "/purchase-motions-components/static-1.6298",
  "salesImages": "/salesImages/static-1.531",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5899",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1233",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4685",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2515",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3209",
  "foundations-theming-base": "/foundations-theming-base/static-1.3711",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5015",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6030",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.29",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.332",
  "chirp-fetch": "/chirp-fetch/static-1.2153",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4735",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4915",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13146",
  "content-media-compositions": "/content-media-compositions/static-2.17153",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4410",
  "magpie-lib": "/magpie-lib/static-1.5727",
  "magpie-types": "/magpie-types/static-1.5187",
  "media-bridge-lib": "/media-bridge-lib/static-1.19351",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4029",
  "superstore": "/superstore/static-1.5015",
  "feedback-loader": "/feedback-loader/static-1.29752",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9626",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8963",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29239",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4685",
  "sassPrefix": "/sassPrefix/static-1.163",
  "react-dnd-compat": "/react-dnd-compat/static-1.4875",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1604",
  "copilot-toolkit": "/copilot-toolkit/static-1.11772",
  "avatar-components": "/avatar-components/static-1.2754",
  "navigation-messaging": "/navigation-messaging/static-1.8063",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8439",
  "commerce-products-lib": "/commerce-products-lib/static-1.10441",
  "crm-message-bus": "/crm-message-bus/static-1.43669",
  "growth-data-modal": "/growth-data-modal/static-1.5836",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5138",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5274",
  "batch-promise": "/batch-promise/static-1.1800",
  "calling-global-api": "/calling-global-api/static-1.65427",
  "calling-internal-common": "/calling-internal-common/static-1.31578",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66809",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59103",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3985",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4489",
  "crm-links": "/crm-links/static-1.6585",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4319",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13289",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9875",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8357",
  "external-options-client-types": "/external-options-client-types/static-1.4312",
  "formula-editor": "/formula-editor/static-1.14692",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7152",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.450",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4396",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.894",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3880",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49575",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4154",
  "property-value-citations": "/property-value-citations/static-1.3083",
  "pulse": "/pulse/static-1.884",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.54",
  "smart-property-lib": "/smart-property-lib/static-1.8201",
  "tiered-pricing": "/tiered-pricing/static-1.1892",
  "trial-components-library": "/trial-components-library/static-1.14043",
  "topics-actions-lib": "/topics-actions-lib/static-1.424",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11245",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3322",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2620",
  "navigation-components": "/navigation-components/static-1.18736",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1126",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7905",
  "ui-universal-auth": "/ui-universal-auth/static-1.9319",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18262",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10546",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5302",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1226",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6287",
  "FileManagerCore": "/FileManagerCore/static-1.39893",
  "FileManagerImages": "/FileManagerImages/static-1.37545",
  "video-components": "/video-components/static-1.14087",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1441",
  "purchase-motions-api": "/purchase-motions-api/static-1.6301",
  "signup-constants": "/signup-constants/static-1.19537",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8319",
  "usage-tracker-public": "/usage-tracker-public/static-1.7427",
  "reactive-lib": "/reactive-lib/static-1.981",
  "simple-logging-lib": "/simple-logging-lib/static-1.3310",
  "chatspot-core": "/chatspot-core/static-1.22712",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6844",
  "cms-field-types": "/cms-field-types/static-1.5074",
  "content-icons-ui": "/content-icons-ui/static-1.2323",
  "integrations-lib": "/integrations-lib/static-1.16954",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.582",
  "breeze-engine-core": "/breeze-engine-core/static-1.882",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1036",
  "customer-data-tracking": "/customer-data-tracking/static-1.7141",
  "products-iframe-lib": "/products-iframe-lib/static-1.8519",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10930",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1588",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2436",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.597",
  "calling-error-reporting": "/calling-error-reporting/static-1.31585",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11299",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6798",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1937",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7508",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6701",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7057",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10631",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4516",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10017",
  "bark-lib": "/bark-lib/static-1.16766",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6149",
  "react-codemirror": "/react-codemirror/static-1.10898",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.271",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4193",
  "persist-promise": "/persist-promise/static-1.3957",
  "event-emitter": "/event-emitter/static-1.1213",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.387",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.590",
  "fsm": "/fsm/static-1.4000",
  "policy-lib": "/policy-lib/static-1.7055",
  "react-tinymce": "/react-tinymce/static-1.55902",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10694",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55028",
  "tinymce-plugins": "/tinymce-plugins/static-1.58142",
  "tinymce-themes": "/tinymce-themes/static-1.56998",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15404",
  "hubs-service-types": "/hubs-service-types/static-1.1518",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2648",
  "user-context-client": "/user-context-client/static-1.4768",
  "nest": "/nest/static-1.495",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1115",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.224",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4792",
  "video-embed": "/video-embed/static-1.36577",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.362",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14369",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5867",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8037",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10627",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.833",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15482",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7869",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36714",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16291",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4770",
  "storybook-react": "/storybook-react/static-1.37",
  "hub-http-contrib": "/hub-http-contrib/static-1.3296",
  "tinymce-data": "/tinymce-data/static-1.41113",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5475",
  "layout-dnd-components": "/layout-dnd-components/static-1.12907",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11882",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16277",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9234",
  "academy-common-lib": "/academy-common-lib/static-1.14864",
  "outpost": "/outpost/static-1.4419",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3266",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.379",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1130",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.955",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.52",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.399",
  "slack-ui-library": "/slack-ui-library/static-1.10658",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10207",
  "academy-service-client": "/academy-service-client/static-1.3948",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4664",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7578",
  "wootric-nps": "/wootric-nps/static-1.7171",
  "advanced-menus-core": "/advanced-menus-core/static-1.15523",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12402",
  "ExportDialog": "/ExportDialog/static-6.10638",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34766",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19163",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20631",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15522",
  "simple-menus-lib": "/simple-menus-lib/static-1.17039",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10763",
  "immutable-less": "/immutable-less/static-1.4910",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18038",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8286",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4180",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8271",
  "nav-meta": "/nav-meta/static-1.30373",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.915",
  "apps-service-types": "/apps-service-types/static-1.4000",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3461"
}
};
